import { useOrganizationContext } from "@/orgs/useOrganizationContext";
import { TAuthConfig, TRefreshTokenExpiredEvent } from "react-oauth2-code-pkce";
import { portalOAuth2ClientId as clientId, portalBackendUrl } from "../config";

function rewriteToSameOriginInDev(absoluteUrl: string): string {
  if (!import.meta.env.DEV) return absoluteUrl;
  // Keep the path/query/hash from the backend, replace scheme+host with the
  // dev server's origin so the browser navigates through the Vite proxy.
  const parsed = new URL(absoluteUrl);
  return `${window.location.origin}${parsed.pathname}${parsed.search}${parsed.hash}`;
}

export function useAuthConfig(): TAuthConfig {
  const organization = useOrganizationContext();

  const authorizationEndpoint = rewriteToSameOriginInDev(
    organization.authorization_endpoint,
  );

  return {
    clientId,
    authorizationEndpoint: authorizationEndpoint,
    tokenEndpoint: `${portalBackendUrl}/oauth/token/`,
    redirectUri: `${document.location.origin}/oauth2/callback`,
    scope: "read",
    autoLogin: false,
    onRefreshTokenExpire: (event: TRefreshTokenExpiredEvent) => event.logIn(),
    // no jwt right now
    decodeToken: false,
    storage: "session",
    clearURL: false,
  };
}
